import React from 'react'

import { AnalyticsIcon, DataIcon, NlpIcon, SettingsIcon } from '../uiKit/icons/Icons'

import NLP from '../tabs/nlp/NlpContainer'
import Settings from '../tabs/settings/Settings'
import Data from '../tabs/data/Data'
import AnalyticsContainer from '../tabs/analytics/AnalyticsContainer'

import { ComponentNames } from '../constants/componentNames'
import { getSidebarIconColorRGB } from '../globalStylesHelper'

const sidebarIconColor = getSidebarIconColorRGB()

export const mainRoutes = [
  // {
  //   path: 'dashboard',
  //   icon: <DashboardIcon width={40} height={20} color={theme.menu.tabListIcon} />,
  //   name: ComponentNames.Dashboard,
  //   component: Dashboard,
  // },
  {
    path: 'analytics',
    icon: <AnalyticsIcon width={40} height={20} color={sidebarIconColor} />,
    name: 'Analytics',
    component: AnalyticsContainer,
  },
  // {
  //   path: 'flows',
  //   icon: <FlowsIcon width={40} height={20} color={theme.menu.tabListIcon} />,
  //   name: ComponentNames.Flows,
  //   component: Builder,
  // },
  {
    path: 'nlp',
    icon: <NlpIcon width={40} height={20} color={sidebarIconColor} />,
    name: ComponentNames.NLP,
    component: NLP,
  },
  // {
  //   path: 'support',
  //   icon: <SupportIcon width={40} height={20} color={theme.menu.tabListIcon} />,
  //   name: ComponentNames.Support,
  //   component: ChatContainer,
  // },
  // {
  //   path: 'broadcast',
  //   icon: <BroadcastIcon width={40} height={20} color={theme.menu.tabListIcon} />,
  //   name: ComponentNames.Broadcasts,
  //   component: Broadcasts,
  // },
  // {
  //   path: 'widget',
  //   icon: <WidgetIcon width={40} height={20} color={theme.menu.tabListIcon} />,
  //   name: ComponentNames.Widget,
  //   component: WidgetContainer,
  // },
  {
    path: 'data',
    icon: <DataIcon width={40} height={20} color={sidebarIconColor} />,
    name: ComponentNames.Data,
    component: Data,
  },
  {
    path: 'settings',
    icon: <SettingsIcon width={40} height={20} color={sidebarIconColor} />,
    name: ComponentNames.BotSettings,
    component: Settings,
  },
]
